import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  /**
   * Obtiene la posición actual del scroll del contenedor mat-sidenav-content
   */
  getScrollPosition(): { scrollX: number; scrollY: number } {
    const scrollElement = document.querySelector(
      '.page-content',
    ) as HTMLElement;

    if (!scrollElement) {
      return { scrollX: 0, scrollY: 0 };
    }

    return {
      scrollX: scrollElement.scrollLeft,
      scrollY: scrollElement.scrollTop,
    };
  }

  /**
   * Restaura la posición del scroll a un valor específico con transición suave
   */
  restoreScrollPosition(position: { scrollX: number; scrollY: number }): void {
    const scrollElement = document.querySelector(
      '.page-content',
    ) as HTMLElement;

    if (!scrollElement) {
      return;
    }

    if (position.scrollX === 0 && position.scrollY === 0) {
      scrollElement.scrollLeft = 0;
      scrollElement.scrollTop = 0;
      return;
    }

    // Habilitar scroll suave temporalmente
    const originalBehavior = scrollElement.style.scrollBehavior;
    scrollElement.style.scrollBehavior = 'smooth';

    // Restaurar la posición
    scrollElement.scrollLeft = position.scrollX;
    scrollElement.scrollTop = position.scrollY;

    // Restaurar el comportamiento original después de la animación
    setTimeout(() => {
      scrollElement.style.scrollBehavior = originalBehavior;
    }, 1000);
  }
}
